import React from 'react';
import { render } from 'react-dom';

import PromotedCarousel from '../react/PromotedCarousel';

export default class PromotedCarouselRender {
  constructor(context) {
    this.context = context;
    this.init();
  }

  init() {
    const { model } = this.context.dataset;
    if (!model) throw Error('Missing a required dataset');
    const jsonModel = JSON.parse(model);

    render(<PromotedCarousel {...jsonModel} />, this.context);
  }
}
